import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import PermissionProvider from 'modules/permissions/PermissionProvider'
import React, {useEffect, useRef, useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {useSelectEntities} from "../../../redux/entities/useSelectEntities";
import {godwords_getById_Api, godwordsSchema} from "../../../apis/godwords";
import {getRouteSearchParams} from "../../../envs/_current/history";
import {getActionRoute, routes, WoGActions} from "./routes";
import RouteWithSubRoutes from "../../../routes/RouteWithSubRoutes";
import {Switch} from 'react-router-dom'

const WoGContext = React.createContext({})

export const WoGProvider = ({
                              id,
                              initialCurrent,
                              children,
                              useExtra = true,
                              filterActions = {},
                              ...props
                            }) => {
  const t = useTranslate()

  const [current, setCurrent] = useState(initialCurrent)

  const modalDismissRef = useRef(NullAsDefault)


  const [refreshKey, setRefreshKey] = useState()

  let searchParams = getRouteSearchParams()

  const {
    response,
    isLoading = false,
    handleAsyncAction = NullAsDefault,
  } = useAsyncAction({
    apiInfo: godwords_getById_Api,
  })

  useEffect(() => {
    handleAsyncAction({}, {id})
  }, [id, refreshKey])


  const item = useSelectEntities(id, godwordsSchema);

  const error = response?.error

  const request_status = response?.status

  const errorMessage = response?.errorMessages?.error

  const error_code = response?.errorMessages?.error_code

  const status = {
    title: request_status,
    description: errorMessage,
  }

  const isSucceed = Number(request_status) === 200
  const onRefresh = () => {
    setRefreshKey(Date.now())
  }

  const handleAction = (action, params) => {
    switch (action) {
      case WoGActions.SHOW_BOOK_INFO_MODAL:
      case WoGActions.SHOW_RELATED_HASH_TAGS_MODAL:
      case WoGActions.SHOW_HASH_TAGS_MODAL:
      case WoGActions.SHOW_MEDITATION_MODAL:
        const pathname = getActionRoute(action)?.path
        if (pathname) {
          setCurrent(pathname)
        }
        break
      default:
        break
    }
  }

  return (
    <WoGContext.Provider
      key={id}
      value={{
        ...props,
        id,
        error,
        status,
        isLoading,
        isSucceed,
        onRefresh,
        refreshKey,
        error_code,
        errorMessage,
        handleAction,
        filterActions,
        modalDismissRef,
        current,
        setCurrent,
        item,
      }}>
      <PermissionProvider
        permissions={{
          edit: !!item?.edit,
          ...(item?.available_actions ?? {}),
        }}>
        <React.Fragment>
          {children}
          {current && (
            <Switch
              location={{
                hash: '',
                search: '',
                key: current,
                pathname: current,
              }}>
              {Object.values(routes).map((route, index) => (
                <RouteWithSubRoutes
                  key={index}
                  {...route}
                />
              ))}
            </Switch>
          )}
        </React.Fragment>
      </PermissionProvider>
    </WoGContext.Provider>
  )
}

export default WoGContext
